import CoreuiController from "../lib/coreui-controller"
import Tooltip from "../coreui/tooltip"

export default class CoreuiTooltipController extends CoreuiController {
  static Component = Tooltip
}
